'use strict';

$(document).ready(function () {
    changeModelDisplay();
    $('#download_file_form_type').on('change', () => {
        $("#download_file_form_model").val('');
        changeModelDisplay();
    });

    function changeModelDisplay() {
        let type = parseInt($('#download_file_form_type').val());
        $("#download_file_form_model option").each(function () {
            let modelType = $(this).data('type');

            if (type === modelType || $(this).data('type') === undefined) {
                $(this).attr('style', 'display: block');
            } else {
                $(this).attr('style', 'display: none');
            }
        });
    }

    function isTypeSelected() {
        return $('#download_file_form_type').val() !== '';
    }

    function enableModelForm() {
        $('#download_file_form_model').attr('disabled', false);
    }

    function disableModelForm() {
        $('#download_file_form_model').attr('disabled', 'disabled');
    }

    function toggleModelFormDisable() {

        if (isTypeSelected()) {
            enableModelForm();
        } else {
            disableModelForm();
        }
    }

    toggleModelFormDisable();

    $('#download_file_form_type').on('input', () => {
        toggleModelFormDisable();
    });
});


// WEBPACK FOOTER //
// ./assets/js/front/download-file-list.js